
<div class="row item-header">
  <div class="col-1 record-img-container"><img [src]="renderRegistro.img" class="record-type-img" /></div>
  <div class="col-11">
      <h6 class="field-title">
        {{renderRegistro.fieldNameWithoutParentheses}}
        <span class="small-text">{{renderRegistro.fieldNameParentheses}}</span>
      </h6>
      <h6 class="date-title">{{renderRegistro.date}}</h6>
  </div>
</div>
<div class="row">
  <div class="col-1 record-img-container-top"><img *ngIf="renderRegistro.img_sync" [src]="renderRegistro.img_sync" class="sync-img"/></div>
  <div class="col-11">
      <p class="first-line">{{renderRegistro.firstLine}}</p>
      <p class="second-line">{{renderRegistro.secondLine}}</p>
      <p class="third-line">{{renderRegistro.thirdLine}}</p>
      <p *ngIf="renderRegistro.syncLineWarning" class="third-line"><span class="warning">Sincronización CUE</span> Pendiente de sincronización</p>
      <p *ngIf="renderRegistro.syncLineError" class="third-line"><span class="error">Error de Sincronización CUE</span></p>
  </div>
</div>

